import { render, staticRenderFns } from "./OrgSidebar.vue?vue&type=template&id=0bb4ba4a&scoped=true&lang=pug"
import script from "./OrgSidebar.vue?vue&type=script&lang=ts"
export * from "./OrgSidebar.vue?vue&type=script&lang=ts"
import style0 from "./OrgSidebar.vue?vue&type=style&index=0&id=0bb4ba4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb4ba4a",
  null
  
)

export default component.exports